import { RouteConfig } from "vue-router";
import { Network } from "@/network";
import { PermissionCode, DefaultPath } from "@/constant/GroupPermission";

const ReconciliationRoute: Array<RouteConfig> = [
    {
        // 請款
        path: "/reconciliation/reimbursement/reimbursement",
        component: () => import("@/views/ap/reconciliation/reimbursement/Reimbursement.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationReimbursement, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },
    {
        // 請款 - 列印頁面
        path: "/reconciliation/reimbursement/reimbursement/print",
        component: () => import("@/views/ap/reconciliation/reimbursement/Print.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationReimbursement, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },
    {
        // 存摺入帳
        path: "/reconciliation/deposit/deposit",
        component: () => import("@/views/ap/reconciliation/deposit/Deposit.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationDeposit, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },
    {
        // 存摺入帳 - 列印頁面
        path: "/reconciliation/deposit/deposit/print",
        component: () => import("@/views/ap/reconciliation/deposit/Print.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationDeposit, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },    
    {
        // 撥款
        path: "/reconciliation/appropriation/appropriation",
        component: () => import("@/views/ap/reconciliation/appropriation/Appropriation.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationAppropriation, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },
    {
        // 撥款 - 列印頁面
        path: "/reconciliation/appropriation/appropriation/print",
        component: () => import("@/views/ap/reconciliation/appropriation/Print.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationAppropriation, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },
    
    /* 報表下載專區" */
    {
        path: "/reconciliation/report/report",
        component: () => import("@/views/ap/reconciliation/report/Report.vue"),
        meta: { privKey: { controller: PermissionCode.BankReconciliation, method: PermissionCode.BankReconciliationReport, type: "get" } },
        beforeEnter: (to, from, next) => {
            if (Network.authCheck()) next();
            else next(DefaultPath);
        }
    },
    /* 報表下載專區" */
];

export { ReconciliationRoute };
